module.exports = __webpack_public_path__ + "img/dab_samir.0c67b23b.jpg";